import { Spinner, YStack } from 'tamagui'

const CobuLoader = ({ size = 'large', color = '$cobuDarkBlue' }: { size?: 'small' | 'large' | undefined, color?: string }) => {
    return (
        <YStack padding="$3" gap="$4" alignItems="center">
            <Spinner size={size} color={color} />
        </YStack>
    )
}

export default CobuLoader;